import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";

import Border from "../Border";

import * as styles from "./styles.module.scss";

const Hero = ({ bottom, center, src, narrowSrc }) => (
  <>
    <div
      className={classNames(styles.container, {
        [styles.bottom]: bottom,
        [styles.center]: center,
      })}
    >
      <img src={src} className={narrowSrc ? styles.wide : undefined} />
      {!!narrowSrc && <img src={narrowSrc} className={styles.narrow} />}
    </div>
    <Border />
  </>
);

Hero.propTypes = {
  bottom: PropTypes.bool,
  center: PropTypes.bool,
  narrowSrc: PropTypes.string,
  src: PropTypes.string.isRequired,
};

export default Hero;
